<template>  
    <div class="warp">
      <!-- 面包屑 -->
      <!-- <breadcrumb :back="false" :crubList="[{name:'首页推荐管理管理'},{name:'融资产品推荐列表'}]" :title="'融资产品推荐列表'"/> -->
      <div ref="condition">
      <el-button
        class="addbtns"
        ref="condition"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="addbtn"
        v-if="authorities.indexOf('sys:permission:background:hotProduct:add')!=-1"
      >添加产品</el-button>
      </div>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        fit
        :height="bHeight"
        :header-cell-style="headerStyle"
        v-loading="loading"
                element-loading-text="请求中......"
      >
        <el-table-column
          prop="sort"
          show-overflow-tooltip
          
          label="序号"
          width="80px"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          
          label="产品名称"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          show-overflow-tooltip
          
          label="贷款类型"
        >
        </el-table-column>
        <el-table-column
          prop="bankName"
          show-overflow-tooltip
          
          label="银行名称"
        >
        </el-table-column>
        <el-table-column
          prop="referee"
          show-overflow-tooltip
          label="推荐人"
        >
        </el-table-column>
        <el-table-column
          prop="refereeTime"
          show-overflow-tooltip
          
          label="推荐时间"
        >
        </el-table-column>
        <el-table-column
          v-if="authorities.indexOf('sys:permission:background:hotProduct:edit')!=-1 ||
                                    (authorities.indexOf('sys:permission:background:hotProduct:del')!=-1)"
          label="操作"
          
          width="200px"
        >
          <template slot-scope="scope">
            <el-button
              class="super" size="small" type="primary" plain
              @click="editoer(scope.row)"
              v-if="authorities.indexOf('sys:permission:background:hotProduct:edit')!=-1"
            >编辑
            </el-button>
            <el-button
              class="super" size="small" type="danger" plain
              v-if="authorities.indexOf('sys:permission:background:hotProduct:del')!=-1"
              @click="deleteDell(scope.row.id)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加热点 -->
      <el-dialog
        title="添加产品"
        :visible.sync="dialogAdd"
        :before-close="resetForm"
        :close-on-click-modal='false'
        width="400"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          v-if="dialogAdd"
        >
          <el-form-item
            label="产品名称"
            prop="sourceId"
            class="formitem"
            v-if="!edit"
          >
            <el-select
              v-model="ruleForm.sourceId"
              placeholder="请选择产品名称"
              filterable
              clearable
              :disabled='edit'
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item,index) in newsDataSelect"
                :key="index"
                @click.native="chooseItem(item)"
              ></el-option>
            </el-select>
          </el-form-item>
          <div
            v-else
            class="nametitle"
          >
            <div>产品名称</div> {{ruleForm.name}}
          </div>

          <el-form-item label="贷款类型">
            <el-input
              disabled
              v-model="ruleForm.type"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行名称">
            <el-input
              disabled
              v-model="ruleForm.bankName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="序号"
            prop="sort"
          >
            <el-input v-model="ruleForm.sort"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
            >确认</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
export default {
    components: {
        // breadcrumb,
    },
    data() {
        return {
          loading:false,
          bHeight: void 0,
            authorities: JSON.parse(window.localStorage.getItem('authorities')),
            sendInfo: {
                currentPage: 1, //页码
                pageSize: 10, //条数
            }, //检索提交数据
            tableData: [], //表格数据
            totalPage: null, //总页码
            dialogAdd: false,
            classifyList: [], //分类
            ruleForm: {
                bankName: null,
                sort: null,
                sourceId: null,
                type: null,
                name:'',
                bankLogo:null,
            },
            edit: false, //是否编辑
            newsDataSelect:[],
            rules: {
                sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.$reg.numPint.test(value) == false) {
                                callback(new Error('请输入正整数'))
                            } else {
                                return callback()
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                sourceId:{ required: true, message: '请选择产品名称', trigger: 'change' }
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    methods: {
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
            })
          },
      // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
      chooseItem(data){
        console.log(data)
        this.ruleForm = Object.assign(this.ruleForm,data)
      },
        // 添加按钮
        async addbtn() {
          // this.edit = false
          // await  this.getSelect()
          this.$router.push({path:`/HomePageMgt/RecommendedList/add`,query:{index:'/HomePageMgt/RecommendedList'}})
        },
        submitForm(formName) {
            console.log(this.ruleForm)
            const that = this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!that.edit) {
                        that.$axioscBody.post('/backstage/hotProduct/add', that.ruleForm).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                await that.getData();
                            } else {
                                that.$alert(r.msg)
                            }
                        })
                    } else {
                        that.$axioscBody.put('/backstage/hotProduct/edit', that.ruleForm).then(async(r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                               await that.getData()
                            } else {
                                that.$alert(r.msg)
                            }
                        })
                    }
                    that.resetForm(formName)
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
          // this.$refs['ruleForm'].resetField();  
          this.ruleForm = {
                bankName: null,
                sort: null,
                sourceId: null,
                type: null,
                name:null,
            }
          this.dialogAdd = false
        },
        // 编辑回显
        editoer(row) {
          // this.ruleForm = row
          // this.edit = true;
          // this.dialogAdd = true
          this.$router.push({path:`/HomePageMgt/RecommendedList/edit/${row.id}`,query:{index:'/HomePageMgt/RecommendedList'},params:{id:row.id}})
        },
        deleteDell(id) {
            const that = this
            that.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$axiosc.delete('/backstage/hotProduct/del', { params: { id: id } }).then(async (r) => {
                    if (r.code == 200) {
                        that.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                       await that.getData()
                    }else {
                        that.$alert(r.msg)
                    }
                })
            }).catch(() => {});
        },
        //切换每页显示条数
        async handleSizeChange(val) {
            this.sendInfo.pageSize = val;
            await this.getData();
        },
        //切换页码
        async handleCurrentChange(val) {
            this.sendInfo.currentPage = val;
            await this.getData();
        },
        //取消按钮
        cancel(type) {
            this.dialogAdd = false;
        },
        async getSelect() {
            const {code,data,msg} = await this.$axiosc.get('backstage/hotProduct/select', {})
            if (code == 200) {
                    this.newsDataSelect = data || [];
                } else {
                    this.$alert(msg)
                }
            this.dialogAdd = true

        },
        //获取数据
        async getData() {
          try{
            this.loading = true
            const {code,data,msg} = await this.$axiosc.get('/backstage/hotProduct/list', {})
            this.loading = false
            if (code == 200) {
                    this.tableData = data || [];
                } else {
                    this.$alert(msg)
                }
          }catch(e){
            this.loading = false
          }
        },
    },
    mounted() {
        const that = this
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  15
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) + 15
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>
<style scoped="scoped" lang="scss">
.forms {
    /deep/ .el-select {
        width: 300px;
    }
    .child {
        .remark {
            /deep/ .el-textarea__inner {
                min-height: 122px !important;
            }
        }
        .name {
            width: 123px;
        }
    }
}

.tabs {
    border: 0;
}

.addbtns {
    margin: 0px 0 10px;
}

/deep/ .el-dialog {
    width: 450px;
}
</style>
